import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Linkedin, Instagram, Youtube, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A1E3F] text-gray-300 pt-12">

      {/* ================= MAIN FOOTER CONTENT ================= */}
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10 pb-12">

        {/* 🔹 About Section */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">About AQUIRAA</h3>
          <p className="text-sm leading-6">
            AQUIRAA is a global data-driven marketing and IT solutions company 
            offering lead generation, data enrichment, and premium web services 
            for businesses across various industries.
          </p>
        </div>

        {/* 🔹 Quick Links */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/industries" className="hover:text-white">Industries</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        {/* 🔹 Policies */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Legal</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* 🔹 Contact + Social */}
<div>
  <h3 className="text-white text-lg font-semibold mb-4">Contact Us</h3>

  {/* 📞 Phone */}
  <div className="flex items-center gap-3 text-gray-300 mb-3">
    <Phone size={18} className="text-white" />
    <a href="tel:+13072434039" className="hover:text-white transition">
      +1 307-243-4039
    </a>
  </div>

  {/* ✉️ Email */}
  <div className="flex items-center gap-3 text-gray-300 mb-5">
    <Mail size={18} className="text-white" />
    <a href="mailto:info@aquiraa.com" className="hover:text-white transition">
      info@aquiraa.com
    </a>
  </div>

  {/* 🌐 Social Media */}
  <div className="flex items-center gap-4">
    <a href="https://www.facebook.com/share/17hbQcky76/?mibextid=wwXIfr" target="_blank" rel="noopener" className="hover:text-white">
      <Facebook size={18} />
    </a>
    <a href="https://www.instagram.com/aquiraa25/" target="_blank" rel="noopener" className="hover:text-white">
      <Instagram size={18} />
    </a>
    <a href="https://www.linkedin.com/company/aquiraa25/?viewAsMember=true" target="_blank" rel="noopener" className="hover:text-white">
      <Linkedin size={18} />
    </a>
    <a href="https://www.youtube.com/@AquiraaSolutions" target="_blank" rel="noopener" className="hover:text-white">
      <Youtube size={20} />
    </a>
  </div>
</div>

      </div>

      {/* ================= BOTTOM BAR ================= */}
      <div className="border-t border-gray-700">
  <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-center text-sm">
    <p className="text-gray-400 text-center">
      © {new Date().getFullYear()} AQUIRAA. All rights reserved.
    </p>
  </div>
</div>

    </footer>
  );
}
